import { render, staticRenderFns } from "./CreateSchool.vue?vue&type=template&id=1333e0a7&"
import script from "./CreateSchool.vue?vue&type=script&lang=js&"
export * from "./CreateSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports